import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  "data-test-id": "filter-name"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  role: "separator",
  class: "divider"
}
const _hoisted_4 = { class: "dropdown-header" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.hasQuery && (!_ctx.query || !_ctx.query.filterName))
      ? (_openBlock(), _createBlock(_component_btn, {
          key: 0,
          size: "xs",
          type: "default",
          "data-test-id": "save-filter-button",
          onClick: _ctx.saveFilterPrompt
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("filter.save.button")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.query && _ctx.query.filterName)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.query.filterName), 1))
      : _createCommentVNode("", true),
    (_ctx.filters && _ctx.filters.length > 0)
      ? (_openBlock(), _createBlock(_component_dropdown, { key: 2 }, {
          dropdown: _withCtx(() => [
            (_ctx.query && _ctx.query.filterName)
              ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
                  _createElementVNode("a", {
                    role: "button",
                    "data-test-id": "delete-filter-btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteFilter && _ctx.deleteFilter(...args)))
                  }, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "glyphicon glyphicon-trash" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("filter.delete.named.text", [_ctx.query.filterName])), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.query && _ctx.query.filterName)
              ? (_openBlock(), _createElementBlock("li", _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "glyphicon glyphicon-filter" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("saved.filters")), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
              return (_openBlock(), _createElementBlock("li", {
                key: filter.filterName,
                "data-test": "filter-item"
              }, [
                _createElementVNode("a", {
                  role: "button",
                  onClick: ($event: any) => (_ctx.selectFilter(filter)),
                  "data-test": "filter-link"
                }, [
                  _createTextVNode(_toDisplayString(filter.filterName) + " ", 1),
                  (_ctx.query && filter.filterName === _ctx.query.filterName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "√"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_5)
              ]))
            }), 128))
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["dropdown-toggle btn btn-secondary btn-sm", _ctx.query && _ctx.query.filterName ? 'text-info' : 'text-secondary'])
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("Filters")) + " ", 1),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "caret" }, null, -1))
            ], 2)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}